/** Valid country dashboard tab route segments */
export const VALID_COUNTRY_DASHBOARD_TABS = [
  'overview',
  'existing-stock',
  'renewable-potential',
  'transmission-line',
  'demand-fuel-price',
  'what-vervestacks',
  'results',
];

export const DEFAULT_GITHUB_LINKS = {
  type: 'single',
  url: 'https://github.com/akanudia/vervestacks_models/tree/main',
};

export const DEFAULT_CHART_HEIGHT = 300;
export const MOBILE_CHART_HEIGHT = 350;
export const DESKTOP_BREAKPOINT_PX = 1024;
export const CHART_HEIGHT_VIEWPORT_THRESHOLD = 1080;
export const CHART_MIN_HEIGHT_SMALL = 200;
export const CHART_MIN_HEIGHT_LARGE = 250;
/** Overview tab container padding, grid gap, chart card padding (2 rows), buffer */
export const OVERVIEW_CHART_PADDING_AND_GAPS = 48 + 16 + 96 + 5;

export const VEDA_ONLINE_DOCS_URL = 'https://vervestacks.readthedocs.io/en/latest/index.html';

/** Static explainer hub in frontend/public/explainers (copied into the production build). */
export const EXPLAINERS_INDEX_PATH = `${process.env.PUBLIC_URL || ''}/explainers/index.html`;

const EXPLAINER_FILM_ISOS = new Set(['DEU', 'IND', 'POL']);

/** Hub opens on that country when films exist; otherwise the default country. */
export function getExplainersHref(isoCode) {
  const iso = String(isoCode || '').trim().toUpperCase();
  if (EXPLAINER_FILM_ISOS.has(iso)) {
    return `${EXPLAINERS_INDEX_PATH}#${iso}`;
  }
  return EXPLAINERS_INDEX_PATH;
}
export const VEDA_ONLINE_PRESENTER_BASE = 'https://vedaonline.cloud/SharedView.aspx?id=';

export const COUNTRY_CARD_BACKGROUND = '#F0F5FF';

/**
 * Tab definitions for country dashboard navigation (labels only; icons were unused in UI).
 * @param {string} [countryName]
 */
export function getCountryDashboardTabs(countryName) {
  return [
    { id: 'overview', name: 'Overview' },
    { id: 'existing-stock', name: 'Existing Stock' },
    { id: 'renewable-potential', name: 'Renewable Potential' },
    { id: 'transmission-line', name: 'Transmission Lines' },
    { id: 'demand-fuel-price', name: 'Demand and Fuel Price Evolution' },
    {
      id: 'what-vervestacks',
      name: 'What VerveStacks can do',
    },
    { id: 'results', name: 'Results' },
  ];
}
